export const RAG = {
  low:      { fg: '#15803d', bg: '#dcfce7' },
  medium:   { fg: '#d97706', bg: '#fef3c7' },
  high:     { fg: '#c2410c', bg: '#ffedd5' },
  critical: { fg: '#b00020', bg: '#fdecea' },
  none:     { fg: '#64748b', bg: '#f1f5f9' },
}

export const NEUTRAL = {
  soft: '#94a3b8',
  faint: '#cbd5e1',
}

export const SCORE_BANDS = [
  { min: 100, level: 'low',      label: 'compliant' },
  { min: 75,  level: 'low',      label: 'on track' },
  { min: 50,  level: 'medium',   label: 'attention' },
  { min: 20,  level: 'high',     label: 'at risk' },
  { min: 0,   level: 'critical', label: 'critical' },
]

export const scoreBandFor = score => {
  if (score === null || score === undefined) return null
  return SCORE_BANDS.find(b => score >= b.min) || SCORE_BANDS[SCORE_BANDS.length - 1]
}

export const RAMP = [RAG.critical.fg, RAG.high.fg, RAG.medium.fg, RAG.low.fg, RAG.low.fg]

export const scoreColour = score => {
  const band = scoreBandFor(score)
  return band ? RAG[band.level].fg : '#cbd5e1'
}

export const scoreBand = score => {
  const band = scoreBandFor(score)
  return band ? band.label : 'no data'
}

export const CRITICALITY_WEIGHT_LEVELS = [
  { min: 4, level: 'critical' },
  { min: 3, level: 'high' },
  { min: 2, level: 'medium' },
  { min: 0, level: 'low' },
]

export const criticalityLevel = weight => {
  if (weight === null || weight === undefined) return 'medium'
  const band = CRITICALITY_WEIGHT_LEVELS.find(b => weight >= b.min)
  return band ? band.level : 'low'
}

export const severityColour = level => (RAG[level] || RAG.none).fg
export const severityBg = level => (RAG[level] || RAG.none).bg

export const formatPercent = score =>
  score === null || score === undefined ? 'No score' : `${Math.round(score)}%`

export const weightedScore = rows => {
  let num = 0, den = 0
  for (const row of rows || []) {
    const score = row?.score
    if (score === null || score === undefined) continue
    let weight = Number(row?.weightDen ?? 0)
    if (weight <= 0) weight = Number(row?.totalTasks ?? row?.total ?? 0)
    if (weight <= 0) weight = 1
    num += Number(score) * weight
    den += weight
  }
  return den > 0 ? Math.round((num / den) * 100) / 100 : null
}
